import type { ElectronContext } from '@mimir/common/context/applicationContext';

// TODO: Get rid of this when we can be sure that no one is using Mimir Desktop versions older than 2.0.0.
// We don't call it for >= 2.2.0
export const getElectronIpcRenderer = (applicationContext: ElectronContext) => {
  if (window.mimirElectron?.ipcRenderer) {
    return window.mimirElectron.ipcRenderer;
  }

  // Fallback to old ways
  const req = applicationContext.rendererRequire;
  if (!req) {
    return;
  }
  return req('electron').ipcRenderer;
};
